import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {TextMessagingPage} from '../../setup/text-messaging/text-messaging-page';

type Props = ContextRouter & {
    // We render this page in two suites and need to redirect
    // and show slightly different content based on where it was started from.
    startedFrom: 'marketing' | 'engagement';
};

export function SmsSettings(props: Props) {
    return <TextMessagingPage {...props} />;
}
